var _linearGradient;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "a",
    gradientTransform: "matrix(1 0 0 -1 0 -15158)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 512,
    y1: -15414,
    y2: -15414
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#08424f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#08424f",
    offset: 0.231
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#08424f",
    offset: 0.5138
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#08424f",
    offset: 0.7773
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#08424f",
    offset: 1
  }))), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
    fill: "url(#a)",
    "data-original": "url(#a)",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m350.703125 329.488281c-.011719-.007812-.019531-.019531-.03125-.027343l-168.285156-168.285157c-.019531-.019531-.035157-.039062-.054688-.054687l-68.226562-68.226563c-5.855469-5.859375-15.351563-5.859375-21.210938 0s-5.859375 15.355469 0 21.210938l56.125 56.125c-28.621093 23-46.390625 48.199219-51.679687 56.238281-11.800782 17.941406-11.800782 41.125 0 59.0625 6.980468 10.617188 26.667968 37.867188 58.589844 61.59375 32.417968 24.097656 66.183593 36.3125 100.355468 36.3125 27.691406 0 55.183594-8.089844 81.878906-24.0625l59.730469 59.734375c2.929688 2.925781 6.769531 4.394531 10.605469 4.394531 3.839844 0 7.679688-1.464844 10.605469-4.394531 5.859375-5.859375 5.859375-15.355469 0-21.214844zm-135.867187-93.4375 16.8125 16.808594c-.933594 7.453125 1.457031 15.238281 7.175781 20.960937 5.722656 5.71875 13.511719 8.109376 20.960937 7.179688l16.175782 16.171875c-6.144532 2.984375-12.929688 4.570313-19.960938 4.570313-25.222656 0-45.742188-20.519532-45.742188-45.742188 0-7.003906 1.59375-13.796875 4.578126-19.949219zm41.445312 117.386719c-61.863281 0-113.261719-53.046875-133.878906-84.390625-5.210938-7.925781-5.210938-18.167969 0-26.089844 4.789062-7.285156 21.292968-30.664062 47.96875-51.371093l22.53125 22.53125c-8.207032 12.328124-12.644532 26.8125-12.644532 41.882812 0 41.765625 33.980469 75.742188 75.742188 75.742188 15.136719 0 29.59375-4.410157 41.90625-12.625l18.242188 18.246093c-19.84375 10.660157-39.917969 16.074219-59.867188 16.074219zm0 0",
    fill: "#ffffff",
    "data-original": "#ffffff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.066406 162.933594c10.398438-2.898438 20.902344-4.371094 31.214844-4.371094 61.585938 0 112.492188 52.628906 133.097656 84.050781.070313.117188.144532.230469.21875.339844 2.550782 3.882813 3.902344 8.394531 3.902344 13.046875s-1.351562 9.164062-3.902344 13.042969c-6.152344 9.351562-14.402344 19.617187-23.230468 28.902343-5.707032 6.003907-5.464844 15.5.539062 21.207032 2.902344 2.757812 6.621094 4.128906 10.332031 4.128906 3.96875 0 7.925781-1.5625 10.875-4.667969 12.839844-13.507812 21.527344-25.449219 26.546875-33.085937 5.785156-8.789063 8.839844-19 8.839844-29.53125 0-10.316406-2.933594-20.328125-8.492188-28.996094-.070312-.117188-.144531-.230469-.21875-.34375-6.921874-10.628906-26.453124-37.917969-58.234374-61.683594-32.3125-24.160156-66.050782-36.410156-100.269532-36.410156-13.042968 0-26.253906 1.839844-39.277344 5.472656-7.980468 2.226563-12.644531 10.5-10.417968 18.480469 2.222656 7.980469 10.5 12.644531 18.476562 10.417969zm0 0",
    fill: "#ffffff",
    "data-original": "#ffffff",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "m272.960938 182.167969c-8.078126-1.847657-16.121094 3.199219-17.96875 11.273437-1.847657 8.074219 3.199218 16.121094 11.273437 17.96875 17.132813 3.925782 30.640625 17.554688 34.410156 34.71875 1.539063 7.007813 7.746094 11.785156 14.636719 11.785156 1.066406 0 2.148438-.113281 3.234375-.351562 8.089844-1.773438 13.210937-9.773438 11.433594-17.867188-6.246094-28.445312-28.628907-51.027343-57.019531-57.527343zm0 0",
    fill: "#ffffff",
    "data-original": "#ffffff",
    style: {}
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.004c3100aa37c0602c7dba1ca41613b3.svg";
export { ForwardRef as ReactComponent };